import styles from './Account.module.scss';
import React, { useState } from 'react';
import Modal from '../../../shared/Modal/Modal';
import ChangePassword from '../../../shared/Modal/ModalContent/ChangePassword/ChangePassword';
import Logout from '../../../shared/Modal/ModalContent/Logout/Logout';
import useComponentVisible from '../../../../hooks/useComponentVisible';
import { getTranslation } from '../../../../utils/translation';
import classNames from 'classnames';

export default function Account(props) {
    const [isVisibleModal, setIsVisibleModal] = useState({
        logoutModal: false,
        changePswdModal: false,
    });

    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

    return (
        <>
            {isVisibleModal.changePswdModal && (
                <Modal
                    isVisible={isVisibleModal.changePswdModal}
                    width='476px'
                    textAlign='center'
                    contentPadding='50px 0'
                >
                    <ChangePassword
                        closeModal={() =>
                            setIsVisibleModal(state => ({ ...state, changePswdModal: false }))
                        }
                    />
                </Modal>
            )}
            {isVisibleModal.logoutModal && (
                <Modal
                    isVisible={isVisibleModal.logoutModal}
                    width='476px'
                    textAlign='center'
                    contentPadding='50px 0'
                >
                    <Logout
                        closeModal={() =>
                            setIsVisibleModal({ ...isVisibleModal, logoutModal: false })
                        }
                    />
                </Modal>
            )}
            <div className={styles.accountDropdown} ref={ref}>
                <div
                    className={styles.dropdownHeader}
                    onClick={() => setIsComponentVisible(!isComponentVisible)}
                >
                    <i className={classNames('icon-user', styles.userIcon)} />
                    <span>
                        {getTranslation('common.cashier')}
                        {': '}
                        <span className={styles.cashierCode}>{props.accountNumber}</span>
                    </span>
                    <i className={classNames('icon-arrow-down', styles.arrowIcon)} />
                </div>
                {isComponentVisible && (
                    <div className={styles.dropdown}>
                        <button
                            className={styles.action}
                            onClick={() =>
                                setIsVisibleModal({ ...isVisibleModal, changePswdModal: true })
                            }
                        >
                            <i className={classNames('icon-lock', styles.icon)} />
                            <span>{getTranslation('common.actions.changePassword')}</span>
                        </button>
                        <button
                            className={styles.action}
                            onClick={() =>
                                setIsVisibleModal({ ...isVisibleModal, logoutModal: true })
                            }
                        >
                            <i className={classNames('icon-logout', styles.icon)} />
                            <span>{getTranslation('common.actions.logout')}</span>
                        </button>
                    </div>
                )}
            </div>
        </>
    );
}
